import { StepState } from '@/enums/step-states';
import { StepType } from '../../../interfaces/enums/step-type';
import IStep from '@/interfaces/step.interface';

export default class GetReadyStep implements IStep {
	public readyToCompleteText = '';
	public stepType = StepType.GET_READY;
	public actions: any[] = [];
	public feedbackGiven = false;
	public icon = 'lnr-briefcase';
	public heading = 'Get Ready';
	public description = "Prepare to move to a new city to start your Master's studies.";
	public selected = 'true';
	public doneCondition(): boolean {
		// some logic here

		return true;
	}

	public stepState(): StepState {
		let allActionsCompleted = false;
		// TODO: connect flag here
		const hasCompletedStep = false;

		if (hasCompletedStep) {
			return StepState.DONE;
		}

		for (const action of this.actions) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			if (!action.done()) {
				allActionsCompleted = false;
			}
		}

		if (allActionsCompleted && !hasCompletedStep) {
			return StepState.READY_TO_COMPLETE;
		}

		return StepState.IN_PROGRESS;
	}
}
